import { enderecoBase } from "@/services/pagesWeb";
import { BaseOperacional } from "@/types/Endereco";
import { regions } from "@/utils/locales";
import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import ImageSvg from "../ui/image-svg";

export const CidadesDistanciaSection = ({
  stateName,
  cityName,
}: {
  stateName: string;
  cityName?: string;
}) => {
  const [baseOperacional, setbaseOperacional] = useState<BaseOperacional[]>([]);

  useEffect(() => {
    const fetchEndereco = async () => {
      const cidadeAtual = regions
        .flatMap((region) => region.cities)
        .find(
          (city) =>
            city.name.toLowerCase() === cityName.toLowerCase() &&
            city.state.toLowerCase() === stateName.toLowerCase(),
        );

      if (!cidadeAtual) {
        throw new Error("Cidade não encontrada");
      }

      try {
        const response = await enderecoBase(cidadeAtual.id);
        setbaseOperacional(response);
      } catch {
        // erro silencioso — endereço base indisponível
      }
    };

    fetchEndereco();
  }, [cityName, stateName]);

  return (
    <section id="cidades-distancia" className="py-10 md:py-24  bg-n-bg-1">
      <div className="container">
        <div className=" grid md:grid-cols-2 gap-8 items-center">
          <div className="flex flex-col gap-4">
            <h2 className="text-n-green text-3xl font-medium md:mb-6 md:text-4xl lg:text-5xl">
              Distâncias da nossa base em {cityName}
            </h2>
            <p className="text-n-text-neutral font-light md:text-lg">
              <span className="font-semibold">Nossa Base em {stateName}:</span>
              <br />
              {baseOperacional.map((base, index) => (
                <span key={index}>
                  {base.bop_descricao}, {base.for_endereco}, {base.for_numero},{" "}
                  {base.for_complemento ? `, ${base.for_complemento}, ` : ""}{" "}
                  {base.for_bairro}, {base.for_cep}, {base.municipio},{" "}
                  {base.mun_codigo}
                </span>
              ))}
            </p>

            {/* <p className="text-n-text-light font-light md:text-lg mb-4">
              Distâncias e Tempos Médios de Viagem de Carro da Base de{" "}
              {stateName}
              para os principais pontos:
            </p>

            <div className="gap-3 text-sm mb-4">
              {filteredCities.map((city, index) => (
                <span
                  key={index}
                  className="text-n-text-light rounded-full flex gap-3 py-1 font-light text-sm md:text-md items-start"
                >
                  <LuMapPin className="min-w-4 h-auto text-n-secondary" />
                  {city}
                </span>
              ))}
            </div> */}

            <Link to="/fazer-cotacao">
              <Button id="btn-fazer-cotacao">
                Agendar meu transporte online <ArrowRight className="ml-2 " />
              </Button>
            </Link>
          </div>

          {/* Imagem mapa ilustrativo */}
          <div className="flex items-center justify-center px-10">
            <ImageSvg
              src="mapa-radar.svg"
              alt={`Distâncias da nossa base em ${cityName}`}
              className="w-[80%]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
